import { useSiteData } from "@/hooks/useSiteData";
import { SmoothScroll } from "./SmoothScroll";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const PageShell = ({ children, testId, footer = true }) => {
  const { settings, gacha } = useSiteData();
  return (
    <div className="grain relative min-h-screen bg-ink text-paper" data-testid={testId}>
      <SmoothScroll />
      <Navbar announcement={settings.announcement} gacha={gacha} />
      <main className="pt-28 md:pt-36">{children}</main>
      {footer ? <Footer settings={settings} /> : null}
    </div>
  );
};

export const RichText = ({ text = "" }) => (
  <div className="prose-bp" data-testid="rich-text">
    {text.split(/\n{2,}/).map((block, i) => {
      if (block.startsWith("## ")) {
        const [head, ...rest] = block.split("\n");
        return (
          <div key={i}>
            <h2>{head.slice(3)}</h2>
            {rest.length ? <p>{rest.join(" ")}</p> : null}
          </div>
        );
      }
      return <p key={i}>{block}</p>;
    })}
  </div>
);
